import axios from "axios"
import VueAxios from "vue-axios"
// const baseurl = "/api/";
const baseurl = "https://hebotc.com/";
export const request = (options)=>{
	return new Promise((resolve,reject)=>{
      let data = options.data || "";
      if(options.method=="post"){
          axios.post(baseurl+options.url,data).then((res)=>{
            resolve(res);
          }).catch((err)=>{
            reject(err);
          });
      }else{
        axios.get(baseurl+options.url,{params:data}).then((res)=>{
          resolve(res);
        }).catch((err)=>{
          reject(err);
        })
      }
	})
}



//////////////////
// WEBPACK FOOTER
// ./utils/request.js
// module id = null
// module chunks = 